var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-usershow"},[_c('img',{attrs:{"src":"https://picbed.qunarzz.com/833228299a3b3cd336175c3c18f17f01.png","alt":""}})])}]

export { render, staticRenderFns }